var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPadlockOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6686 16.3743H10.3314C8.99651 16.3743 7.91431 17.4565 7.91431 18.7914V33.2943C7.91431 34.6293 8.99651 35.7114 10.3314 35.7114H29.6686C31.0036 35.7114 32.0857 34.6293 32.0857 33.2943V18.7914C32.0857 17.4565 31.0036 16.3743 29.6686 16.3743Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.46 16.3743V12.7486C28.46 10.5048 27.5688 8.353 25.9822 6.76646C24.3956 5.17989 22.2438 4.28857 20 4.28857C17.7563 4.28857 15.6045 5.17989 14.0179 6.76646C12.4314 8.353 11.54 10.5048 11.54 12.7486V16.3743",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 27.2514C20.6675 27.2514 21.2086 26.7103 21.2086 26.0429C21.2086 25.3754 20.6675 24.8343 20.0001 24.8343C19.3326 24.8343 18.7915 25.3754 18.7915 26.0429C18.7915 26.7103 19.3326 27.2514 20.0001 27.2514Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPadlockOutline);
export default __webpack_public_path__ + "static/media/icon_padlock_outline.ab58021400cf5f5748b1b79b9aa5a6f7.svg";
export { ForwardRef as ReactComponent };